import styled from "styled-components";
import { MainButtonContainer } from "../../components/main-button/main-button-style";
import { InputBoxContainer } from "../../components/input-box/input-box-style";
import { colors, images } from "../../assets";
import { BodyTextContainer } from "../../components/components-text/body-text/body-text-styles";


export const UpdateRequestsContainer = styled.div`

font-family: "museo sans";
  .save-footer {
    display:flex;
  }
  h4 {
    color: red;
    align-items: center;
    font-size: 20px;
    margin: 0;
    }
  .atention{
    background: wheat;
    width: fit-content;
    padding-block: 9px;
    padding-inline: 6px;
    }
   .updateRequests-content {
    display: flex;
    background:red;
  }
  .updateRequests-left  {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 300px;
    width: 100%;
    max-width: 400px;
    margin-right: 20px;
    color: #004f8b;

    .updateRequests-left-top {
      &__title  {
        font-size: 53px;
        line-height: 62px;
        color: #004f8b;
        margin-bottom: 20px;
        font-weight: 700;
      }
      &__subtitle {
        font-size: 18px;
        line-height: 30px;
        color: #004f8b;
        max-width: 300px;
      }
    }

    .updateRequests-info  {
      margin-bottom: 20px;
    }

    .updateRequests-info-item {
      display: flex;
      margin-bottom: 12px;
      &:last-of-type {
        margin-bottom: 0px;
      }
      &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 12px;
        font-size: 12px;
        line-height: 14px;
        color: #004f8b;
        opacity: 0.99;
      }
      &__link {
        width: 100%;
      }
    }
  }

  .updateRequests-right {
    background: #b2cadc14;
    border-radius: 3px;
    width: 100%;
    padding: 40px;
    max-width: 700px;

    .updateRequests-right-form {
      margin-bottom: 60px;
    }
    .updateRequests-right-input {
      margin-bottom: 28px;
    }
  }
    .add-updateRequests-modal-button {
      display: flex;
      justify-content: flex-end;
      ${MainButtonContainer} {
        width: 190px;
        margin-top: 16px;
      }
    }

    &__button {
      width: 142px;
      ${MainButtonContainer} {
        height: 40px;
      }
    }

  .left-align{
      flex-direction: row-reverse;
      display: flex;
  }
  .container-column{
      margin-top:20px
  }
  .updateRequests-columns-container {
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;  
    margin-top:20px;
  }

  .updateRequests-column {
    display:flex;
    width:100%;
  }

  .first-row{
    width: 60% !important;
    margin-right: 80px;
  }

  .updateRequests-row {
    width: 15% !important;
    margin-bottom: 16px;
    padding-right: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .updateRequests-container {
    margin-bottom: 38px;
    ${InputBoxContainer} {
      input {
        border-radius: 3px;
        padding-top: 6px;
        padding-bottom: 9px;
        top: 45%;
      }
    }
  }

`;